<div [ngClass]="['loader', isActive ? 'active' : '']"></div>
